import { useNavigate } from 'react-router-dom';

import { VerifyEmailForm } from '@ekhodealer/ekho-common/auth-client';

import { useCompleteEmailVerification } from '@features/setup/api/useCompleteEmailVerification';
import { SetupHeader } from '@features/setup/components/SetupHeader';
import { paths } from '@config/paths';

/**
 * Setup Verify Email page - thin wrapper around ekho-common VerifyEmailForm.
 * Injects SetupHeader and useCompleteEmailVerification for admin portal setup flow.
 */
export default function SetupVerifyEmailPage() {
	const navigate = useNavigate();
	const { mutateAsync: completeEmailVerification, isPending: isCompletingVerification } =
		useCompleteEmailVerification();
	const continueUrl = `${window.location.origin}${paths.userManagement.getHref()}`;

	return (
		<VerifyEmailForm
			onCompleteVerification={async () => {
				await completeEmailVerification();
			}}
			isCompletingVerification={isCompletingVerification}
			renderHeader={({ title, details }) => <SetupHeader title={title} details={details} />}
			continueUrl={continueUrl}
			onBackToLogin={() => navigate('/login')}
		/>
	);
}
